import { MeteredAddOnUsage } from "@addons/components/MeteredAddOnUsage";
import { IAddOnSlotProps, IMeteredAddOnDescriptor } from "../types";

export default function StorageRentUsageGraph({
  addOn: { subscribed, getUsage, getPricePerUnit },
}: IAddOnSlotProps<IMeteredAddOnDescriptor>) {
  const usage = getUsage();
  const pricePerRow = getPricePerUnit();

  if (!subscribed || !usage || pricePerRow === undefined) {
    return null;
  }

  return (
    <MeteredAddOnUsage
      dataTestId="StorageRentUsageListing"
      unitLabel="Stored rows"
      maxUnitLabel="stored rows"
      usage={usage}
      pricePerUnit={pricePerRow}
    />
  );
}
